export const subscriptionList = (req) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'site_id': req?.site_id,
      'access_token': req?.access_token
    },
  };
  return fetch(`/shared/api/subscription/subscriptionService?currency_code=${req?.currency_code}`, requestOptions).then((response) => response.json())

}

export const subscribedList = (query) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'access_token': query?.accessToken,
      'site_id': query?.site_id
    },
    body: JSON.stringify(query)
  };

  console.log('request options in subscription service', requestOptions)
  return fetch('/shared/api/subscription/subscribedList', requestOptions).then((response) => response.json())
}



export const planDetail = (query) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'access_token': query?.access_token,
      'site_id': query?.site_id
    },
    body: JSON.stringify(query)
  };
  return fetch('/shared/api/subscription/planDetails', requestOptions).then((response) => response.json())
}

export const subscritionBooking = (query) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'access_token': query?.access_token,
      'site_id': query?.site_id
    },
    body: JSON.stringify(query)
  };
  return fetch('/shared/api/subscription/booking', requestOptions).then((response) => response.json())
}

export const subscriptionOrderDetails = (query) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'access_token': query?.accessToken,
      'site_id': query?.site_id
    },
    body: JSON.stringify(query)
  };
  return fetch('/shared/api/subscription/orderDetails', requestOptions).then((response) => response.json())
}



export const subscribedListV2 = (query) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      // Authorization: "",
    },
    // body: JSON.stringify(query)
  };

  return fetch(`api/subscription/subscribedListV2?current=${query.current}`, requestOptions).then((response) => response.json())
}

export const planDetailsV2 = (query) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      // Authorization: "",
    },
    // body: JSON.stringify(query)
  };

  return fetch(`api/subscription/planDetailsV2`, requestOptions).then((response) => response.json())
}

export const getUserSubscriptionDetails = (query) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      // Authorization: "",
    },
    body: JSON.stringify(query)
  };

  return fetch(`api/subscription/getUserSuscription`, requestOptions).then((response) => response.json())
}